import React from "react";
import { Page } from "../Page";
import { api } from "../../api/api";
import { Table } from "../../core/ui/Table";
import { useConditional } from "../../core/hooks/useConditional";
import { newID } from "../../core/utils/unique";
import { useApi } from "../../core/hooks/useApi";
import { PdfDesigner } from "../../pdf-designer/PdfDesigner";
import { CopyToClipboardCol, IDCol, LastUpdatedCol, SyncTableCol, TagsCol, TitleCol, VersionCol } from "../../layout/TableCells";
import { FormModal } from "../../data-entry/FormModal";
import { report_def, ReportStructure } from "../../core/pdf/types";


export function Reports(props: {

}) {

	const [token, setToken] = React.useState("");

	const createModal = useConditional(() => {
		return (
			<FormModal
				form="report-create"
				onCancel={createModal.close}
				onSave={(value: any) => {

					const rep = {
						id: value.id,
						title: "New Report",
						deleted: 0,
						data: {
							id: "@",
							layoutType: value.layoutType,
							template: value.template,
							sections: [
								{
									type: "section",
									content: [{
										type: "p",
										segments: [],
									}],
								}
							],
						},
					};

					api.report_def_post(rep).then(() => {
						setToken(newID());
						createModal.close();
					}).catch(() => {

					});					

				}}
			/>
		)
	});

	const reports = useApi({
		request: () => api.report_def_get_all(),

		prepareResult: (result: report_def[]) => {
			result.sort((a, b) => {
				return (a ? a.title : "").localeCompare(b ? b.title : "");
			});

			return result;
		}
	}, [token]);

	const edit = useConditional((def: report_def) => {

		function handleSave(structure: ReportStructure, title: string) {
			def.data = structure;
			def.title = title;
	
			return api.report_def_post(def);
		}
		
		return (
			<PdfDesigner
				def={def}

				onCancel={edit.close}

				onDelete={() => {
					api.report_def_delete(def).then(() => {
						setToken(newID());
						edit.close();
					}).catch(() => {

					})
				}}

				onSave={(structure, title, close) => {
					handleSave(structure, title).then(() => {
						if (close) edit.close();
					}).catch(() => {
			
					});					
				}}

				onPreview={(structure, title) => {
					// first save
					handleSave(structure, title).then(() => {
						// launch preview
						const w = window.open(`/pdf/${encodeURIComponent(def.id)}/`, "pdf-preview");
						w?.focus();

					}).catch(() => {

					});
				}}
			/>
		)
	});


	return (
		<Page
			compact={true}
			title={{
				text: "Reports",
				icon: "report_color",
				buttons: [
					{ title: "Create" }
				]
			}}
			onButton={(btn) => {
				createModal.show({});
			}}
		>

			<Table
				cols={[
					VersionCol(),
					IDCol(),
					TitleCol(),
					TagsCol(),
					LastUpdatedCol(),
					SyncTableCol({ container: "report_def", onSync: () => {
						setToken(newID());
					} }),
					CopyToClipboardCol(),
				]}
				items={reports ? reports : []}
				interactive={true}
				onClick={(e, r) => {
					// first prepare the form (linking in subforms)
					edit.show(r);
				}}
			/>
			{edit.render()}
			{createModal.render()}

		</Page>
	);
}





// export function EditForm(props: {
// 	def: form_def,
// 	onSave: () => void,
// 	onDelete: () => void,
// }) {
// 	const { def } = props;

// 	const formValues = {};

// 	if (!def) return null;

// 	function save() {
// 		// can't save the in-memory structure - it has things that shouldn't be persisted

// 		const obj = {
// 			id: def.id,
// 			title: def.title,
// 			deleted: def.deleted,
// 			data: JSON.parse(JSON.stringify(def.data)),
// 		};

// 		// also check through any subform references and remove the elements[] which were injected
// 		// and remove any unique ids
// 		function scan(e: any) {
// 			if (e.uniqueID) delete e.uniqueID;

// 			if (e.type === "sub-form") {
// 				delete e.elements;
// 			}

// 			if (e.elements) {
// 				for(let child of e.elements) {
// 					scan(child);
// 				}
// 			}
// 		}
// 		scan(obj.data);


// 		api.form_def_post(obj).then(() => {
// 			props.onSave();

// 		}).catch(() => {

// 		});
	
// 	}

// 	return(
// 		<Modal
// 			title="Edit Form"

// 			onSave={save}
// 			onCancel={props.onSave}
// 			cancelOnEscapeKey={false}
// 			saveOnEnterKey={false}

// 			showDelete={true}
// 			onDelete={props.onDelete}
// 		>
// 			<InspectorContainer>
// 				<Presenter
// 					designMode={true}

// 					def={def.data as Element}
// 					refs={def.refs}
// 					subForms={def.subForms}

// 					formValues={formValues}
// 				>
// 					<Inspector />
// 				</Presenter>				
// 			</InspectorContainer>
// 		</Modal>
// 	);
// }